import type { GetOfferResponseLegacy } from '../../api-specs-buyback/customer/getOfferLegacy'
import { createHttpEndpoint } from '../../utils'

import type { CartResponse } from './cart.types'

/**
 * Retrieve cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/Cart}
 */
export const getCart = createHttpEndpoint<CartResponse>({
  method: 'GET',
  operationId: 'fetchCart',
  path: '/bm/cart',
  transformResponseToCamelCase: true,
})

/**
 * Add a listing to the cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartAddProduct}
 */
export const addToCart = createHttpEndpoint({
  method: 'POST',
  operationId: 'addToCart',
  path: '/bm/cart/add_product',
})

/**
 * Add bundle of listings to the cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartAddProducts}
 */
export const addProductsToCart = createHttpEndpoint({
  method: 'POST',
  operationId: 'addProductsToCart',
  path: '/bm/cart/add_products',
})

/**
 *
 * Add service to cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#/Checkout%20services/CartAddService}
 */
export const addServiceToCart = createHttpEndpoint({
  method: 'POST',
  operationId: 'addServiceToCart',
  path: '/bm/cart/services',
})

/**
 * Retrieve swap from cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#/default/CartSwapGet}
 */
export const getSwap = createHttpEndpoint<GetOfferResponseLegacy>({
  method: 'GET',
  operationId: 'getSwap',
  path: '/bm/cart/swap',
})

/**
 * Update selected shipping option for a listing.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartShippingsPost}
 */
export const postShippings = createHttpEndpoint({
  method: 'POST',
  operationId: 'saveCartShippings',
  path: '/bm/cart/shippings',
})

/**
 * Update collection point in cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartUpdateCollectionPointPost}
 */
export const postUpdateCollectionPoint = createHttpEndpoint({
  method: 'POST',
  operationId: 'updateCartCollectionPoint',
  path: '/bm/cart/update-collection-point',
})

/**
 * Update user information
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartUpdateUserInformation}
 */
export const postUpdateUserInformation = createHttpEndpoint({
  method: 'POST',
  operationId: 'updateUserInformation',
  path: '/bm/cart/update-user-information',
})
